import React, { useState } from "react";
import { Box, Button, Link, Typography } from "@mui/material";
import GetAppOutlinedIcon from "@mui/icons-material/GetAppOutlined";
import { usePwaInstall } from "../hooks/usePwaInstall";
import { BRAND } from "../styles/authTheme";

const PwaInstallPrompt = ({ variant = "button" }) => {
  const { canInstall, showIosHint, promptInstall } = usePwaInstall();
  const [isPrompting, setIsPrompting] = useState(false);

  if (!canInstall && !showIosHint) {
    return null;
  }

  if (showIosHint) {
    return (
      <Typography
        variant="caption"
        display="block"
        align="center"
        sx={{ mt: 2, color: BRAND.muted, lineHeight: 1.5, px: 1 }}
      >
        Install Thryiv Kiosk: tap{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          Share
        </Box>{" "}
        then{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          Add to Home Screen
        </Box>
      </Typography>
    );
  }

  const handleInstall = async () => {
    setIsPrompting(true);
    try {
      await promptInstall();
    } finally {
      setIsPrompting(false);
    }
  };

  if (variant === "link") {
    return (
      <Box sx={{ mt: 2, textAlign: "center" }}>
        <Link
          component="button"
          type="button"
          underline="hover"
          onClick={handleInstall}
          disabled={isPrompting}
          aria-label="Install Thryiv Kiosk app"
          sx={{
            color: BRAND.orange,
            fontWeight: 600,
            fontSize: "0.875rem",
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
            cursor: "pointer",
            border: "none",
            background: "none",
            fontFamily: "inherit",
            "&:hover": { color: BRAND.orangeHover },
          }}
        >
          <GetAppOutlinedIcon sx={{ fontSize: "1.1rem" }} />
          Install Thryiv Kiosk
        </Link>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 2.5 }}>
      <Button
        fullWidth
        variant="outlined"
        onClick={handleInstall}
        disabled={isPrompting}
        startIcon={<GetAppOutlinedIcon />}
        aria-label="Install Thryiv Kiosk app"
        sx={{
          color: BRAND.orange,
          borderColor: BRAND.orange,
          borderRadius: "10px",
          py: 1.25,
          fontWeight: 600,
          fontSize: "0.875rem",
          textTransform: "none",
          "&:hover": {
            borderColor: BRAND.orangeHover,
            bgcolor: BRAND.orangeLight,
          },
        }}
      >
        Install Thryiv Kiosk
      </Button>
    </Box>
  );
};

export default PwaInstallPrompt;
